export default __webpack_public_path__ + "static/media/icon_topaz.292f4f95.png";